export enum ChannelValue {
  STORE_CUSTOMER = "fdc31d4e-e2b7-44c9-98aa-aec3612e498b",
  STORE_FACTORY = "78fb8946-65ed-49d6-bc9b-7ef9843e77ba",
  PRIVATE = "37257159-ac7c-452e-953d-a0c8016ba7ce",
  SYSTEM_UPGRADE_NOTIFICATION = "e3a1f8b2-7c4d-4a9e-b6d5-2f8e1c3a9b7d",
}

export function isSystemUpgradeNotificationChannel(channel: string): boolean {
  if (!channel) {
    return false;
  }

  return channel === ChannelValue.SYSTEM_UPGRADE_NOTIFICATION;
}
